export const SETTINGS_MODAL_ID = 'settingsModal1';
export const SETTINGS_ROOT_ID = 'scc-settings-react-root';
export const SETTINGS_SCHEMA_ID = 'scc-settings-modal-schema';

export const GROUP_LABELS = {
	'FRONTEND OPTIONS': 'General',
	'DETAILS LIST & PDF SETTINGS': 'Detailed List & PDF',
	'CURRENCY & TAX SETTINGS': 'Currency & Tax',
	'EMAIL SETTINGS': 'Email Settings',
	'WEBHOOK EVENTS TRIGGER': 'Webhook Events',
	'SMS SETTINGS': 'Text Message (SMS)',
	'TEXT MESSAGE (SMS) SETTINGS': 'Text Message (SMS)',
};
